import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function UTMPersistor() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Get all query params
    const searchParams = new URLSearchParams(location.search);

    // Filter for keys starting with 'utm_'
    const allParams = {};
    [...searchParams.entries()].forEach(([key, value]) => {
      if (key.startsWith("utm_")) { 
        allParams[key] = value;
      }
    });

    // Store in sessionStorage if any params found
    if (Object.keys(allParams).length > 0) {
      sessionStorage.setItem("tracking_params", JSON.stringify(allParams));
    }

    // If URL has no tracking params, restore from sessionStorage
    if (Object.keys(allParams).length === 0) {
      const stored = sessionStorage.getItem("tracking_params");
      if (stored) {
        const savedParams = JSON.parse(stored);
        const newParams = new URLSearchParams(location.search);

        Object.entries(savedParams).forEach(([key, value]) => {
          if (!newParams.has(key)) newParams.set(key, value);
        });

        // Only update URL if something changed
        if (newParams.toString() !== location.search.slice(1)) {
          navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
        }
      }
    }
  }, [location, navigate]);

  return null;
}

export default UTMPersistor;